import React, { useState, useEffect, useRef } from 'react';
import CommonSlider from './partials/commonslider';

const About = () => {
  // Animation states for different sections
  const [isAboutSectionVisible, setIsAboutSectionVisible] = useState(false);
  const [isLocalExperiencesVisible, setIsLocalExperiencesVisible] = useState(false);
  const [isFacilitiesVisible, setIsFacilitiesVisible] = useState(false);
  const [isTestimonialsVisible, setIsTestimonialsVisible] = useState(false);
  
  // Refs for targeting sections
  const aboutSectionRef = useRef(null);
  const localExperiencesRef = useRef(null);
  const facilitiesRef = useRef(null);
  const testimonialsRef = useRef(null);

  // Scroll-triggered animations using Intersection Observer
  useEffect(() => {
    const observers = [];

    // About section animation
    if (aboutSectionRef.current) {
      const aboutObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                setIsAboutSectionVisible(true);
              }, 200);
              aboutObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        }
      );
      aboutObserver.observe(aboutSectionRef.current);
      observers.push(aboutObserver);
    }

    // Local experiences section animation
    if (localExperiencesRef.current) {
      const localObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                setIsLocalExperiencesVisible(true);
              }, 300);
              localObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        }
      );
      localObserver.observe(localExperiencesRef.current);
      observers.push(localObserver);
    }

    // Facilities section animation
    if (facilitiesRef.current) {
      const facilitiesObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                setIsFacilitiesVisible(true);
              }, 200);
              facilitiesObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        }
      );
      facilitiesObserver.observe(facilitiesRef.current);
      observers.push(facilitiesObserver);
    }

    // Testimonials section animation
    if (testimonialsRef.current) {
      const testimonialsObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                setIsTestimonialsVisible(true);
              }, 200);
              testimonialsObserver.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -50px 0px'
        }
      );
      testimonialsObserver.observe(testimonialsRef.current);
      observers.push(testimonialsObserver);
    }

    // Cleanup function
    return () => {
      observers.forEach(observer => observer.disconnect());
    };
  }, []);

  return (
    <main>
      <CommonSlider />

      <div className="petti_bg_r" ref={aboutSectionRef}>
        <div className="container margin_120_95">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-5">
              <div className="parallax_wrapper inverted">
                <img src="/assets/img/aboutus/1.webp" alt="About Us" className="img-fluid rounded-img" />
                <div data-cue="slideInUp" className="img_over">
                  <span data-jarallax-element="-60"
                  style={{ zIndex: 0, transform: 'translate3d(0px, 25px, 0px)', position: 'relative' }}>
                    <img src="/assets/img/aboutus/2.webp" alt="About Us" className="rounded-img" />
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="intro">
                <div className="title">
                  <small className={`animate-slide-up ${isAboutSectionVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.1s', color: '#fff' }}>We are Petti Petti</small>
                  <h2 className={`animate-slide-up ${isAboutSectionVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.2s', color: '#fff' }}>OUR JOURNEY SO FAR</h2>
                </div>
                <p className={`lead animate-slide-up ${isAboutSectionVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.3s', color: '#fff', fontWeight: '400' }}>
                  Nestled along the pristine shores of the azure southern coastline, Petti Petti invites guests to indulge in and succumb to the coastal joys. We truly set the stage for sublime experiences in Mirissa.
                </p>
                <h3 className={`ceofont animate-slide-up ${isAboutSectionVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.4s', color: '#fff' }}>
                  NISAL HETTIARCHCHI,<span style={{ fontSize: '1.5rem', fontWeight: '400' }}>
                    <br />FOUNDER
                  </span>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="petti_cream_rep" ref={localExperiencesRef}>
        <div className="container margin_120_95" id="first_section">
          <div className="row justify-content-between">
            <div className="col-xl-4 fixed_title" style={{ paddingBottom: '40px', position: 'sticky', top: '100px', alignSelf: 'flex-start' }}>
              <div className="title cream-round-box">
                <h2 className={`animate-slide-up ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.1s' }}>Local experiences</h2>
                <p className={`lead animate-slide-up ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.2s', fontWeight: '400' , color : '#227b74' }}>
                  Discover our pristine beaches, towns where history meets modernity and exhilarating water sports, all within a stone's throw of Petti Petti!
                </p>
              </div>
            </div>
            <div className="col-xl-7">
              <div className={`row_list_version_3 animate-fade-in ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.3s' }}>
                <div className="owl-carousel owl-theme carousel_item_1 kenburns rounded-img">
                  <div className="item">
                    <img src="/assets/img/localattract/coconut.webp" alt="Coconut Tree Hill" />
                  </div>
                  <div className="item">
                    <img src="/assets/img/localattract/coconut2.webp" alt="Coconut Tree Hill" />
                  </div>
                </div>
                <div className="box_item_info">
                  <h2>Coconut Tree Hill</h2>
                  <p>Perched atop Mirissa's Coconut Tree Hill, enjoy panoramic ocean views and breathtaking sunsets, offering a tranquil escape for nature lovers.</p>
                  <div className="facilities clearfix">
                    <ul>
                      <li>700m from Petti Petti</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className={`row_list_version_3 animate-fade-in ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.4s' }}>
                <div className="owl-carousel owl-theme carousel_item_1 kenburns rounded-img">
                  <div className="item">
                    <img src="/assets/img/localattract/parrotrock.webp" alt="Parrot Rock" />
                  </div>
                </div>
                <div className="box_item_info">
                  <h2>Parrot Rock</h2>
                  <p>Parrot Rock in Mirissa, Sri Lanka, offers stunning ocean views, golden shores, and breathtaking sunsets—a perfect seaside escape.</p>
                  <div className="facilities clearfix">
                    <ul>
                      <li>210m from Petti Petti</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className={`row_list_version_3 animate-fade-in ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.5s' }}>
                <div className="owl-carousel owl-theme carousel_item_1 kenburns rounded-img">
                  <div className="item">
                    <img src="/assets/img/localattract/secretbeach.webp" alt="Secret Beach" />
                  </div>
                  <div className="item">
                    <img src="/assets/img/localattract/secretbeach2.webp" alt="Secret Beach" />
                  </div>
                </div>
                <div className="box_item_info">
                  <h2>Secret Beach</h2>
                  <p>Secret Beach is a hidden gem with golden sands, clear waters, and serene vibes—perfect for a peaceful escape.</p>
                  <div className="facilities clearfix">
                    <ul>
                      <li>2.5km from Petti Petti</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className={`row_list_version_3 animate-fade-in ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.6s' }}>
                <div className="owl-carousel owl-theme carousel_item_1 kenburns rounded-img">
                  <div className="item">
                    <img src="/assets/img/localattract/whalewatching.webp" alt="Whale Watching" />
                  </div>
                </div>
                <div className="box_item_info">
                  <h2>Whale Watching</h2>
                  <p>Witnessing majestic whales in Mirissa, is an unforgettable adventure filled with awe, excitement, and breathtaking ocean views.</p>
                  <div className="facilities clearfix">
                    <ul>
                      <li>Tours can be arranged at Petti Petti</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className={`row_list_version_3 animate-fade-in ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.7s' }}>
                <div className="owl-carousel owl-theme carousel_item_1 kenburns rounded-img">
                  <div className="item">
                    <img src="/assets/img/localattract/surfing.webp" alt="Surfing" />
                  </div>
                </div>
                <div className="box_item_info">
                  <h2>Surfing</h2>
                  <p>Surfing in Mirissa offers an exhilarating ride on perfect waves, set against a stunning tropical backdrop.</p>
                  <div className="facilities clearfix">
                    <ul>
                      <li>Surfing classes can be arranged at Petti Petti</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className={`row_list_version_3 animate-fade-in ${isLocalExperiencesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.8s' }}>
                <div className="owl-carousel owl-theme carousel_item_1 kenburns rounded-img">
                  <div className="item">
                    <img src="/assets/img/localattract/gallefort.webp" alt="Galle Fort" />
                  </div>
                </div>
                <div className="box_item_info">
                  <h2>Day Trip To Galle Fort</h2>
                  <p>Exploring Galle Fort, a UNESCO World Heritage site built in 1588 by the Portuguese and later fortified by the Dutch, offers a captivating journey through time, showcasing a blend of European architectural styles and South Asian traditions.</p>
                  <div className="facilities clearfix">
                    <ul>
                      <li>Tours can be arranged at Petti Petti</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="pinned-image pinned-image--medium" ref={facilitiesRef}>
        <div className="pinned-image__container aboutusimg">
          <img src="/assets/img/aboutus/facilities.webp" alt="Facilities" />
          <div className="pinned-image__container-overlay"></div>
        </div>
        <div className="pinned_over_content">
          <div className="title white center mb-5">
            <h2 className={`animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.1s', color: '#ebdbcc' }}>Facilities</h2>
          </div>
          <div className="row mt-4">
            <div className="col-xl-3 col-lg-6 col-md-6 col-6">
              <div className={`box_facilities white no-border animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.2s' }}>
                <img className="facisize" src="/assets/img/icons/parking.png" alt="Parking" />
                <h3 style={{ color: '#ebdbcc' }}>Private Parking</h3>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-6">
              <div className={`box_facilities white animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.3s' }}>
                <img className="facisize" src="/assets/img/icons/mobile.png" alt="WiFi" />
                <h3 style={{ color: '#ebdbcc' }}>High Speed Wifi</h3>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-6">
              <div className={`box_facilities white animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.4s' }}>
                <img className="facisize" src="/assets/img/icons/drink.png" alt="Bar & Restaurant" />
                <h3 style={{ color: '#ebdbcc' }}>Bar & Restaurant</h3>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-6">
              <div className={`box_facilities white animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.5s' }}>
                <img className="facisize" src="/assets/img/icons/pool.png" alt="Swimming Pool" />
                <h3 style={{ color: '#ebdbcc' }}>Swimming Pool</h3>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-6">
              <div className={`box_facilities white no-border animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.6s' }}>
                <img className="facisize" src="/assets/img/icons/music.png" alt="Live Music" />
                <h3 style={{ color: '#ebdbcc' }}>Live & DJ Music</h3>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-6">
              <div className={`box_facilities white animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.7s' }}>
                <img className="facisize" src="/assets/img/icons/beachfront.png" alt="Beachfront" />
                <h3 style={{ color: '#ebdbcc' }}>Beachfront</h3>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-6">
              <div className={`box_facilities white animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.8s' }}>
                <img className="facisize" src="/assets/img/icons/cabanas.png" alt="Cabanas" />
                <h3 style={{ color: '#ebdbcc' }}>Cabanas & Lounges</h3>
              </div>
            </div>
            <div className="col-xl-3 col-lg-6 col-md-6 col-6">
              <div className={`box_facilities white animate-slide-up ${isFacilitiesVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.9s' }}>
                <img className="facisize" src="/assets/img/icons/beds.png" alt="Day Beds" />
                <h3 style={{ color: '#ebdbcc' }}>Day Beds</h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="petti_f_bg">
        <div className="container margin_120_95">
          <div className="row justify-content-between margin_30_0">
            <div className="col-lg-4">
              <div className="title">
                <h3 style={{ color: '#fff' }}>Frequently Asked Questions</h3>
              </div>
              <p style={{ color: '#fff' }}>
                Can't find your question in the list? Let us know your questions.
              </p>
              <p>
                <a href="/contact" className="animated_link" style={{ color: '#fff' }}>
                  <strong>Contact Us <i className="bi bi-arrow-right"></i></strong>
                </a>
              </p>
            </div>
            <div className="col-lg-7 col-12">
              <div role="tablist" className="mb-5 accordion" id="faq">
                <div className="card">
                  <div className="card-header" role="tab">
                    <h5 className="mb-0">
                      <a className="collapsed" data-bs-toggle="collapse" href="#collapseOne_product" aria-expanded="false" style={{ color: '#18373b' }}>
                        <i className="indicator bi-plus-lg"></i>How can we reserve lounges at Petti Petti Mirissa?
                      </a>
                    </h5>
                  </div>
                  <div id="collapseOne_product" className="collapse" role="tabpanel" data-bs-parent="#faq" style={{ backgroundColor: '#eadacb', color: '#18373b' }}>
                    <div className="card-body">
                      <p>You can reserve our lounges simply by clicking on the "Reserve Your Lounge" button on our website. It will lead to our lounges page and you can select the type of lounge you prefer. After selecting your preferred lounge, simply click the "Enquire Now" button and it will open a WhatsApp chat with our reservation manager.</p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" role="tab">
                    <h5 className="mb-0">
                      <a className="collapsed" data-bs-toggle="collapse" href="#collapseTwo_product" aria-expanded="false" style={{ backgroundColor: '#eadacb', color: '#18373b' }}>
                        <i className="indicator bi-plus-lg"></i>Can we book Petti Petti Mirissa for a private event?
                      </a>
                    </h5>
                  </div>
                  <div id="collapseTwo_product" className="collapse" role="tabpanel" data-bs-parent="#faq" style={{ backgroundColor: '#eadacb', color: '#18373b' }}>
                    <div className="card-body">
                      <p>Yes, you can book Petti Petti Mirissa for a private event. You can reach us at +94761407881 or email at reservations@oryzaleisure.com to discuss about your enquiry.</p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" role="tab">
                    <h5 className="mb-0">
                      <a className="collapsed" data-bs-toggle="collapse" href="#collapseThree_product" aria-expanded="false" style={{ backgroundColor: '#eadacb', color: '#18373b' }}>
                        <i className="indicator bi-plus-lg"></i>How can we use the Pool at Petti Petti?
                      </a>
                    </h5>
                  </div>
                  <div id="collapseThree_product" className="collapse" role="tabpanel" data-bs-parent="#faq" style={{ backgroundColor: '#eadacb', color: '#18373b' }}>
                    <div className="card-body">
                      <p>You can reach out to any of our staff at Petti Petti Mirissa to gain access to the our pool.</p>
                    </div>
                  </div>
                </div>
                <div className="card">
                  <div className="card-header" role="tab">
                    <h5 className="mb-0">
                      <a className="collapsed" data-bs-toggle="collapse" href="#collapseFour_product" aria-expanded="false" style={{ backgroundColor: '#eadacb', color: '#18373b' }}>
                        <i className="indicator bi-plus-lg"></i>Are pets allowed at Petti Petti?
                      </a>
                    </h5>
                  </div>
                  <div id="collapseFour_product" className="collapse" role="tabpanel" data-bs-parent="#faq" style={{ backgroundColor: '#eadacb', color: '#18373b' }}>
                    <div className="card-body">
                      <p>Unfortunately, we don't allow pets at Petti Petti Mirissa for the convenience of all our guests.</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="parallax_section_1 jarallax" data-jarallax data-speed="0.2" ref={testimonialsRef}>
        <img className="jarallax-img" src="/assets/img/aboutus/reviews.webp" alt="Reviews" />
        <div className="wrapper opacity-mask d-flex align-items-center justify-content-center text-center" data-opacity-mask="rgba(0, 0, 0, 0.5)">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div className="title white">
                  <small className={`mb-1 animate-slide-up ${isTestimonialsVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.1s' }}>Testimonials</small>
                  <h2 className={`animate-slide-up ${isTestimonialsVisible ? 'animate-visible' : ''}`} style={{ animationDelay: '0.2s', color: '#eadacb' }}>What Our Guests Says</h2>
                </div>
                <div className="carousel_testimonials owl-carousel owl-theme nav-dots-orizontal">
                  <div>
                    <div className="box_overlay">
                      <div className="pic">
                        <h4>Elkin H<small>Apr 2024</small></h4>
                      </div>
                      <div className="comment">
                        "During our stay in mirissa we went to petti petti for a swim in the pool and some food and drinks. The staff was very helpfull, place is clean en the vibe is amazing ! wish we could have stayed longer."
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="box_overlay">
                      <div className="pic">
                        <h4>Shirishnv<small>Feb 2024</small></h4>
                      </div>
                      <div className="comment">
                        "Petti Petti Mirissa is right on the beach. With a pool right in the middle & live music playing, it is one of the happening places in Mirissa. We had Calamari for a snack, Crab & Spaghetti & Fish for the main course. The food was very good as was the ambience & location...right on Mirissa Beach."
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="box_overlay">
                      <div className="pic">
                        <h4>Cat H<small>Jan 2024</small></h4>
                      </div>
                      <div className="comment">
                        "The food here is amazing! We ended up eating lunch AND dinner here because the food and service were so good. All of the employees were so nice and super attentive. If I could rate them higher, I would."
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default About;

